module.exports = __webpack_public_path__ + "static/media/linkedin.52a1b36d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/LayoutFooter/linkedin.svg
// module id = 508
// module chunks = 2